import { defineElement, html, TemplateElement } from '@webtides/element-js';
import { classMap } from 'lit-html/directives/class-map.js';

import style from './arrow-box.css';
const directions = 'up|left|right|down';
export default class ArrowBox extends TemplateElement {
    constructor() {
        super({ shadowRender: true, adoptGlobalStyles: false, styles: [style] });
    }

    properties() {
        return {
            arrow: directions,
        };
    }

    template() {
        const arrowClasses = {
            'arrow-up': this.arrow === 'up',
            'arrow-down': this.arrow === 'down' || this.arrow === directions,
            'arrow-left': this.arrow === 'left',
            'arrow-right': this.arrow === 'right',
        };
        // inputs value needs to be set as the last attribute otherwise it will cause a range error and display wrong initial value
        return html`
            <slot></slot>
            <div class="arrow ${classMap(arrowClasses)}"></div>
        `;
    }
}

defineElement('arrow-box', ArrowBox);
